import React from 'react';
import Switch, { ReactSwitchProps } from 'react-switch';
import { UIC } from 'tuui/lib/utils/typing';
import { ThemeColor } from 'tuui/lib/theme/base';
import { colors as semantic } from 'tuui/lib/theme/colors';

export interface ToggleSwitchProps extends ReactSwitchProps {
    color?: ThemeColor;
}

const SwitchFixed = Switch as unknown as React.FC<ReactSwitchProps>;

// TODO: Remove this once we have a proper color palette migrated
const paletteHex = {
    primary:   semantic.action.primary.base,
    success:   semantic.alert.success.content,
    info:      semantic.alert.info.content,
    warning:   semantic.alert.warning.content,
    error:     semantic.alert.error.content,
    disabled:  semantic.action.primary.disabled,
} as const;

type ToggleColor = keyof typeof paletteHex; 

export const ToggleSwitch: UIC<ToggleSwitchProps> = ({
    color = 'primary',
    height = 11,
    width = 21,
    checked,
    checkedIcon,
    uncheckedIcon,
    ...rest
}: ToggleSwitchProps) => {
    const switchColor = paletteHex[(color as ToggleColor)] ?? paletteHex.primary;

    return (
        <SwitchFixed
            {...rest}
            onColor={switchColor}
            height={height}
            width={width}
            checked={!!checked}
            checkedIcon={checkedIcon ?? false}
            uncheckedIcon={uncheckedIcon ?? false}
        />
    );
};
